import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';

import type { AccommodationState, OverrideValues } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { scrollToElementById } from '@/utils/scroll';
import { focusElementById } from '@/utils/focus';
import { SelectedFilterItem } from '../../../../components/selectedFilterItem/SelectedFilterItem';

interface StateProps {
    hotelName?: string;
}

interface DispatchProps {
    filterByHotelName: (hotelName?: string) => void;
    triggerFetch: () => void;
}

export type SelectedKeywordFilterProps = StateProps & DispatchProps & { openFilters: () => void };

export const SelectedKeywordFilter = ({ hotelName, filterByHotelName, triggerFetch, openFilters }: SelectedKeywordFilterProps) => {
    if (!hotelName) {
        return null;
    }

    const removeFilter = (): void => {
        filterByHotelName(undefined);
        triggerFetch();
    };
    const openFiltersAndScrollToId = () => {
        openFilters();
        scrollToElementById('HotelNameFilter');
        focusElementById('HotelNameFilter');
    };

    return <SelectedFilterItem value={`Hotellnavn: ${hotelName}`} removeFilter={removeFilter} openFilters={openFiltersAndScrollToId} />;
};

const mapStateToProps = (state: AccommodationState): StateProps => ({
    hotelName: state.filters.hotelName,
});

const mapDispatchToProps: OverrideValues<DispatchProps, ActionCreator<unknown>> = {
    filterByHotelName: actions.filterByHotelName,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedKeywordFilter);
